import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { serverUrl } from '../../../Constant/Static/config';
import Loader from '../../../Constant/Custom/Loader';

ChartJS.register(ArcElement, Tooltip, Legend);

function VerifierStatus({ verifierData }) {
    const [loading, setLoading] = useState(true);
    const [csrfToken, setCsrfToken] = useState('');
    const [waiting, setWaiting] = useState(0);
    const [notEligible, setNotEligible] = useState(0);
    const [pending, setPending] = useState(0);
    const [verified, setVerified] = useState(0);

    useEffect(() => {
        const fetchCsrfToken = async () => {
            try {
                const response = await axios.get(`${serverUrl}/api/csrf-token`, {
                    withCredentials: true
                });
                setCsrfToken(response.data.csrfToken);
            } catch (error) {
                console.error('Error fetching CSRF token:', error);
            }
        };

        fetchCsrfToken();
    }, []);

    useEffect(() => {
        const fetchUserData = async () => {
            if (csrfToken) {
                try {
                    const response = await axios.post(
                        `${serverUrl}/api/cv/verifier/stats`,
                        {
                            user_id: verifierData.USER_ID,
                            mobile: verifierData.MOBILE,
                        },
                        {
                            headers: {
                                'CSRF-Token': csrfToken
                            },
                            withCredentials: true
                        }
                    );
                    // // console.log(response);
                    if (response.status === 200) {
                        // console.log(response.data);
                        response.data.statsData.forEach(item => {
                            if (item.STATUS === 'E') setNotEligible(item.COUNT);
                            if (item.STATUS === 'W') setWaiting(item.COUNT);
                            if (item.STATUS === 'P') setPending(item.COUNT);
                            if (item.STATUS === 'V') setVerified(item.COUNT);
                        });
                    } else {
                        // console.log('Error fetching data');
                    }
                } catch (error) {
                    console.error('Error fetching user data:', error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchUserData();
    }, [csrfToken]);


    const data = {
        labels: ['Waiting List', 'Not Eligible', 'Pending', 'Verified'],
        datasets: [
            {
                label: 'Allotted Status',
                data: [waiting, notEligible, pending, verified],
                backgroundColor: ['#36A2EB', '#dc3545', '#FF6384', '#3D8D7A'], // Colors for the donut chart
                hoverBackgroundColor: ['#36A2EB', '#dc3545', '#FF6384', '#3D8D7A'],
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        const label = data.labels[tooltipItem.dataIndex];
                        const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.dataIndex];
                        return `${label}: ${value}`;
                    },
                },
            },
        },
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <div className='chart-sub-container'>
            <h4>Verifier Alloted Status</h4>
            <Doughnut data={data} options={options} />
        </div>
    );

}

export default VerifierStatus;